<template>
    <PopupRouterView :showLeftIcon="true" label="Control Time"
        okTitle="Save"
        cancelTitle="Cancel"
        ref="popUpModal"
        modalClass="input-scan-page">

        <!-- APP_DETAIL_HEADER -->
		<template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2" v-if="type == 'datetime'">

			<div v-for="(item, indexGroup) in groupCategory" :key="indexGroup">
				<br>
				<span class="bold">{{ item.groupName }}</span>
				<b-row v-for="(category, index) in item.categories" :key="index" class="to-do-list">
					<b-col cols="12" class="flex-item start-item control-time-title">
						<p class="blue-text">{{ category.name }}</p>
					</b-col>
					<b-col cols="12" md="6">
						<new-date-time-picker label-cols-lg="2" label="From" :model="category.dateTimeFrom" @update:model="(value) => updateDateTimeFrom(category, value)" />
					</b-col>
					<b-col cols="12" md="6">
						<new-date-time-picker label-cols-lg="1" label="To" :model="category.dateTimeTo" @update:model="(value) => updateDateTimeTo(category, value)" />
					</b-col>
				</b-row>
			</div>

		</div>
		<div class="p-2" v-else-if="type == 'duration'">
			<div v-for="(item, indexGroup) in groupCategory" :key="indexGroup">
				<br>
				<span class="bold">{{ item.groupName }}</span>
				<b-row v-for="(category, index) in item.categories" :key="index" class="to-do-list">
					<b-col cols="12">
						<app-input-textbox id="fieldset-" type="number" label-cols-lg="1"  :label="category.name" label-for="input-" size="sm" />
					</b-col>

				</b-row>
			</div>
		</div>

		<div class="p-2" v-else>
			<div v-for="(item, indexGroup) in groupCategory" :key="indexGroup">
				<br>
				<span class="bold">{{ item.groupName }}</span>
				<b-row v-for="(category, index) in item.categories" :key="index" class="to-do-list">
					<b-col cols="12" class="flex-item start-item control-time-title">
						<p class="blue-text">{{ category.name }}</p>
					</b-col>
					<b-col cols="12" md="6">
						<new-time-picker label-cols-lg="2" label="From" />
					</b-col>
					<b-col cols="12" md="6">
						<new-time-picker label-cols-lg="1" label="To" />
					</b-col>
				</b-row>
			</div>
		</div>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template>
<style>

p {
		margin: 0 !important
	}
	.to-do-list {
		margin: 15px 0;
	}
	.blue-text {
		color :rgb(52, 187, 228)
	}
	.input-label-detail {
		font-size: 25px !important;
		word-wrap: break-word;
		line-height: 1.3 !important;
	}
	.big-text {
		font-size: 40px !important;
	}
	.scannerText { 
		font-size: 24px;
		margin: 10px auto;
		display: block;
		text-align: center;
		color: black !important;
	}
	.flex-item {
		display: flex;
		align-items: center;
	}
	.start-item {
		justify-content: flex-start;
	}
	.center-item {
		justify-content: center;
	}
	.end-item {
		justify-content: flex-end;
	}
	.user-avatar, .shift-row {
		margin: 20px 0;
	}
	.shift-row {
		border-bottom: 1px solid rgb(94, 94, 94);
	}
	.shift-title {
		font-size: 20px;
		color: #626F9C;
	}
	.big-btn {
		font-size: 24px !important;
		font-weight: bold !important;
		background-color: #FFC978 !important;
		padding: 10px 100px !important;
	}
	.bold {
		font-weight: bold !important;
	}
	.control-time-title {
		font-size: 20px;
		margin: 10px 0;
	}
	.bg-white {
		background: white !important;
	}

	.input-scan-page .form-control {
		font-size: 16px !important;
	}
	
	.production-time {
		display: flex;
		flex-direction: column;
		align-items: center
	}

	.fixed-header {
		position: fixed;
		margin-top: -35px;
		max-width: 970px;
		width: 970px;
		padding: 0px;
		background-color: white; /* Ensure it has a background color */
		z-index: 1000; /* Adjust the z-index if necessary */
		/* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
		/*margin-left: -25px;*/
	}

</style>
<script>
import moment from 'moment';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
import NewDateTimePicker from '@/components/AppInputDateTimePickerCustomPineda.vue';
import NewTimePicker from '@/components/AppInputTimePickerPineda.vue';
export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView, 
		NewDateTimePicker,
		NewTimePicker
	},
	data() {
		return {
			isBusy: false,
			gap: 10,
			groupCategory: [
				{
					groupName: 'NOT LOSS TIME',
					categories: [
						{
							name: 'Time 1',
							dateTimeFrom: '',
							dateTimeTo: '',
						},
						{
							name: 'Time 2',
							dateTimeFrom: '',
							dateTimeTo: '',
						},
					]
				},
				{
					groupName: 'LOSS TIME',
					categories: [
						{ 
							name: 'Trouble 1',
							dateTimeFrom: '',
							dateTimeTo: '', 
						}, 
						{ 
							name: 'Trouble 2',
							dateTimeFrom: '',
							dateTimeTo: '', 
						}, 
						{ 
							name: 'Trouble 3',
							dateTimeFrom: '',
							dateTimeTo: '', 
						}, 
					]
				}
			]
		}
	},
	methods: {
		updateDateTimeFrom(obj, dateFromValue) {
			if(!obj.dateTimeTo) {
				let dateFormat = moment(dateFromValue, 'YYYY-MM-DD HH:mm');
				if(dateFormat != 'Invalid Date') {
					obj.dateTimeFrom = dateFromValue;
					obj.dateTimeTo = dateFormat.add(10, 'minutes').format('YYYY-MM-DD HH:mm');
				}
			}
		},
		updateDateTimeTo(obj, dateToValue) {
			if(!obj.dateTimeFrom) {
				let dateFormat = moment(dateToValue, 'YYYY-MM-DD HH:mm');
				if(dateFormat != 'Invalid Date') {
					obj.dateTimeTo = dateToValue;
					obj.dateTimeFrom = dateFormat.add(-10, 'minutes').format('YYYY-MM-DD HH:mm');
				}
			}
		}
	},
	computed: {
		type() {
			return this.$route.params.type;
		}
	}
	
}
</script>
